import { setScrollButton } from './pagination';
import addLazyLoad from '../lazyLoad';
import changeSize from '../wishlist/changeSize';
function removeAlertWishlist() {
    document.querySelectorAll('form[data-component="remove-alert-wishlist"]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            await fetch(form.action, {
                method: 'post',
                body: new FormData(form),
            });
            form.closest('li').remove();
            return false;
        });
    });
}
export default function initWishlist() {
    const setWishlistScrollButton = () => {
        if (document.querySelector('button.js-btn-paginate') !== null) {
            setScrollButton('section#wishlist', () => {
                addLazyLoad();
                removeAlertWishlist();
            });
            setScrollButton('section#alert', () => {
                addLazyLoad();
            });
        }
    };
    setWishlistScrollButton();
    changeSize();
    removeAlertWishlist();
}
